//src/main.ts

import { ComponentPublicInstance, createApp } from 'vue'
import { createPinia } from 'pinia'

// Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
// @ts-ignore
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

// @ts-ignore
import { ProCalendar } from '@lbgm/pro-calendar-vue'

import App from './App.vue'
import router from './router'

// Global CSS (Vuetify + custom)
import '@/assets/buttons.css'
import '@/assets/vuetify-overrides.css'

const vuetify = createVuetify({
  components,
  directives
})

const app = createApp(App)

if (import.meta.env.DEV) {
  app.config.warnHandler = (msg, instance, trace) => {
    if (String(msg).includes('computed value is readonly')) {
      // narrow to an internal-ish shape to satisfy TS
      type AnyInst = ComponentPublicInstance & {
        type?: any
        $?: any
        $options?: any
      }
      const inst = instance as AnyInst | null

      const name = inst?.type?.name ?? inst?.$?.type?.name ?? inst?.$options?.name ?? '(anonymous)'

      const file =
        inst?.type?.__file ?? inst?.$?.type?.__file ?? inst?.$options?.__file ?? '(unknown file)'

      console.group('%c⚠️ Computed write detected', 'color:#e65100;font-weight:600')
      console.log('Message:', msg)
      console.log('Component:', name)
      console.log('File:', file)
      console.log('Trace:', trace)
      console.trace('Stack') // jumps to your caller
      console.groupEnd()
      return
    }
    console.warn(msg, trace)
  }
}

//app.use(vuetify).use(createPinia()).use(router).use(ProCalendar).mount('#app')
app.use(vuetify).use(createPinia()).use(router).use(ProCalendar)
app.mount('#app')

//added after for debugging
app.config.errorHandler = (err, instance, info) => {
  console.error('🔥 Vue errorHandler:', err, info, instance)
}
window.addEventListener('unhandledrejection', (e) =>
  console.error('🔥 unhandledrejection:', e.reason)
)
window.addEventListener('error', (e) => {
  if (e.error === null) return // ignore synthetic browser/extension events
  console.error('🔥 window error:', e.error)
})
